import { Injectable, ApplicationRef, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { filter, first, interval } from 'rxjs';
import { ConfirmDialogService } from './confirm-dialog.service';
import { I18nService } from './i18n.service';

@Injectable({ providedIn: 'root' })
export class SwUpdateService {
  private appRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate);
  private confirmService = inject(ConfirmDialogService);
  private translate = inject(I18nService);

  checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) return;

    // 🔑 Wait until app is stable (CRITICAL for SSR)
    this.appRef.isStable.pipe(first(stable => stable)).subscribe(() => {
      // Periodic check
      interval(15 * 1000).subscribe(() => {
        this.swUpdate.checkForUpdate();
      });

      // Listen for updates
      this.swUpdate.versionUpdates
        .pipe(filter(e => e.type === 'VERSION_READY'))
        .subscribe(() => this.promptUser());
    });
  }

  private async promptUser(): Promise<void> {
    const accepted = await this.confirmService.updateVersionConfirmationDialog(
      ' ',
      this.translate.translate('updateVersionBild')
    );

    if (accepted) {
      await this.swUpdate.activateUpdate(); // 🔥 REQUIRED in SSR
      document.location.reload();
    }
  }
}
